import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { QuotesComponent } from './quotes.component';
import { AuthGuard } from '../../services/auth-guard.service';
import { DynamicFormModule } from '../shared/controls/dynamic/dynamic-form.component';
import { LoadingModule } from '../shared/controls/loading.component';
import { NotesModule } from '../shared/controls/notes.component';
import { LastUpdatedModule } from '../shared/controls/last-updated.component';

import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { QuoteListComponent } from './quote-list.component';
import { SortIconCustomModule } from '../shared/controls/dynamic/sort-icon-custom.component';
import { DynamicValueModule } from '../shared/controls/dynamic/dynamic-value.component';
import { VehiclesDetailModule } from '../shared/controls/vehicles-detail.component';
import { PaginatorCustomModule } from '../shared/controls/dynamic/paginator-custom.component';
import { SimpleControlModule } from '../shared/controls/dynamic/simple-control.component';
import { CheckboxModule } from 'primeng/checkbox';
import { UserFormModule } from '../users/user-form.component';
import { OrderFormModule } from '../orders/order-form.component';
import { QuoteFormComponent } from './quote-form.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { VehiclesFormModule } from '../shared/controls/vehicles-form.component';
import { ModalLeftNavModule } from '../shared/controls/dynamic/modal-left-nav.component';
import { QuoteDetailComponent } from './quote-detail.component';
import { RowToolsModule } from '../shared/controls/row-tools.component';
import { NotesDetailModule } from '../shared/controls/notes-detail.component';
import { LocationFormModule } from '../locations/location-form.component';


@NgModule({
  declarations: [
    QuotesComponent,
    QuoteFormComponent,
    QuoteListComponent,
    QuoteDetailComponent,
  ],
  imports: [
    CommonModule,
    TableModule,
    ReactiveFormsModule,
    DynamicFormModule,
    NotesModule,
    DialogModule,
    LoadingModule,
    DropdownModule,
    FormsModule,
    ButtonModule,
    LastUpdatedModule,
    SortIconCustomModule,
    DynamicValueModule,
    VehiclesDetailModule,
    PaginatorCustomModule,
    SimpleControlModule,
    CheckboxModule,
    UserFormModule,
    OrderFormModule,
    VehiclesFormModule,
    ModalLeftNavModule,
    MultiSelectModule,
    RowToolsModule,
    NotesDetailModule,
    LocationFormModule,
    RouterModule.forChild([
      {
        path: '',
        component: QuotesComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', component: QuoteListComponent, canActivate: [AuthGuard] },
        ]
      }
    ])
  ],
  exports: [
    QuotesComponent,
    QuoteFormComponent,
    QuoteListComponent,
    QuoteDetailComponent,
  ]
})
export class QuotesModule { }

